/**
 * Decision and confidence badges shown beside Prediction Summary on the
 * questionnaire page — same visual treatment as the Prediction Summary modal.
 *
 * @module pharmaQuestionaire/components/MnJudgePreviewBadges
 */
import DecisionBadge from "../../../components/modals/predictionSummaryModal/components/decisionBadge";
import { EvaluationDecision } from "../../../components/modals/predictionSummaryModal/types";

/**
 * Props for the MN judge preview badge pair.
 */
interface MnJudgePreviewBadgesProps {
  /** Normalized evaluation decision from the latest assessment. */
  decision: EvaluationDecision;
  /** Confidence percent from the latest assessment. */
  confidence: number;
}

/**
 * Renders decision + confidence badges matching the Prediction Summary modal.
 *
 * @param props - Decision and confidence from the MN judge preview fetch
 * @returns Badge pair for the questionnaire toolbar
 */
const MnJudgePreviewBadges = ({
  decision,
  confidence,
}: MnJudgePreviewBadgesProps) => {
  return (
    <div className="flex items-center gap-2">
      <DecisionBadge decision={decision} />
      <span className="rounded bg-tertiaryBlue-12 px-2 py-1 text-tiny font-semibold text-tertiaryBlue-4">
        {confidence}%
      </span>
    </div>
  );
};

export default MnJudgePreviewBadges;
